// Core
import React, { act, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment-timezone";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Button from "Components/Button";
import FooterColorLineData from "Services/data/footerColorLineData";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import firstPage from "../../Assets/Images/pdfFirstPage.jpg";
import { notifySuccess } from "Services/Utils/toastNotification";
// Styles
import "./styles.scss";

// Redux
import {
  getAssessmentReport,
  getPastAssessment_USER,
  getPendingtAssessment_USER,
  getLatestAssessment_USER,
  getReportDetailspdfData,
  viewUserFeedback,
  getPdfData,
  multiUpload,
  updatePdfURL
} from "../../Redux/Slices/User/userSlice";
import {
  setReportId,
  clearReportId,
} from "../../Redux/Slices/User/reportSlice";

// Assets
import Noreports from "../../Assets/Svg/Auth/Noreports.svg";
import BackArrow from "../../Assets/Svg/Auth/BackArrow.svg";

// Custom components
import DropdownDetails from "Components/DropdownDetails";
import CardHero from "Components/CardHero";
import Assessment from "Components/ScheduledAssesment";
import PastAssessmentCard from "Components/PastAssessmentCard";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { ReportDownload } from "Components/ReportDownload";
import Loader from "Components/Loader";

export default function Reports({ reportType, setActiveComponent }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [submitName, setSubmitName] = useState("");
  const [schuledAssessmentData, setSchuledAssessmentData] = useState([]);
  const [activeTab, setActiveTab] = useState(reportType);
  const [loading, setLoading] = useState(true);
  const [reportData, setReportData] = useState(null);
  const [feedbackData, setFeedbackData] = useState(null);
  const [userName, setUserName] = useState("");
  const [pastAssessments, setPastAssessments] = useState({ item: [] });
  const [latestReport, setLatestReport] = useState(null);
  const [showall, setshowAll] = useState(false);
  const [isShowDownload, setIsShowDownload] = useState(false)
  const [pdfReport, setPdfReport] = useState(null)
  const [scores, setScores] = useState(null)
  const downloadRef = useRef()

  const { reportId } = useSelector((state) => state.report);
  const isLoading = useSelector((state) => state.user.isLoading);
  const [isLoader, setisLoader] = useState(false)

  // Fetch Past Assessments on Mount

  // Combine all initial data fetching into one useEffect
  useEffect(() => {
    const fetchInitialData = async () => {
      setLoading(true);
      try {
        await Promise.all([
          dispatch(getPastAssessment_USER({ callBack: loadPastAssessments })),
          dispatch(getPendingtAssessment_USER({ callBack: getSchuledAssessmentUsers })),
          dispatch(getLatestAssessment_USER({
            callBack: (data) => {
              setLatestReport(data?.data);
            },
          }))
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchInitialData();
  }, [dispatch]);

  useEffect(() => {
    if (reportId) {
      setLoading(true);
      dispatch(getAssessmentReport({
        reportId,
        callBack: (data) => {
          setReportData(data);
          setLoading(false);
        }
      }));
      dispatch(getPdfData({
        reportId,
        callBack: (data) => {
          getScores(data)
          setPdfReport(data);
          setLoading(false);
        }
      }));
    }
  }, [dispatch, reportId]);

  const getScores = (data) => {
    const scoreMap = {}
    data?.result?.map((item) => {
      item?.performance_results?.map((it) => {
        scoreMap[it?.category_name] = it?.average_score
      })
    })
    setScores(scoreMap)
  }

  useEffect(() => {
    if (reportId) {
      dispatch(
        viewUserFeedback({
          data: {
            backlog_id: reportId,
            isUser: "true",
          },
          callBack: (data) => {
            setFeedbackData(data.data.data);
          },
        })
      );
    }
  }, [reportId, dispatch]);

  const loadPastAssessments = (response) => {
    setPastAssessments(response?.data?.data_list || []);
    // setPastAssessments ([]);
    setUserName(response?.userName || "");
  };

  const getSchuledAssessmentUsers = (data) => {
    setSchuledAssessmentData(
      Array.isArray(data?.data?.datas) ? data.data.datas : []
    );
    setSubmitName(data?.data?.userName);
  };

  // Fetch Report Details when reportId changes
  useEffect(() => {
    if (reportId) {
      setLoading(true);
      dispatch(
        getAssessmentReport({ reportId, callBack: setReportDataAndLoading })
      );
    }
  }, [dispatch, reportId]);

  const setReportDataAndLoading = (data) => {
    setReportData(data);
    setLoading(false);
  };

  // Tab Switch Handlers
  const switchToLatest = () => {
    dispatch(clearReportId());
    setActiveTab("latest");
  };

  const switchToPast = () => {
    dispatch(clearReportId());
    setActiveTab("past");
  };

  const handleViewAssessment = (id) => {
    navigate(`/pre-assessment/view/${id}`);
  };

  const handleViewRecommendation = (id) => {
    navigate(`/pre-assessment/recommendation/${id}`);
  };

  // Report View Handlers
  const viewReport = (backlogId) => {
    dispatch(setReportId(backlogId));

    dispatch(
      viewUserFeedback({
        data: {
          backlog_id: backlogId,
          isUser: "true",

        },
        callBack: (data) => {
          console.log("API response:", data);
          setFeedbackData(data.data.data);
        },
      })
    );
  };

  // Render Helper Functions //previous assessment
  const renderPastAssessments = () => {
    if (isLoading === 'loading') {
      return (
        <div>
          <Skeleton height={30} width={200} style={{ marginBottom: "10px" }} />
          <Skeleton count={4} height={100} style={{ marginBottom: "15px" }} />
        </div>
      );
    }

    return (
      <div>
        <h1 className="pending-assessment-subheading">Past Assessments Report</h1>
        {pastAssessments?.length > 0 ? (
          pastAssessments?.map((item) => (
            <PastAssessmentCard
              key={item.assessment_id}
              data={item}
              assessmentName={item?.assessment_name}
              assessmentSubmittedDate={item?.submitted_at ? moment(item?.submitted_at).tz("Asia/Kolkata").format(
                "DD-MM-YYYY"
              ) : "-"}
              assessorName={item?.assessment_backlog?.users?.assessor_name || 'N/A'}
              userName={userName}
              showViewReport={true}
              showViewRecommendations={false}
              referenceName={item?.assessment_backlog?.reference_name}
              handleViewAssessment={() => handleViewAssessment(latestReport.firstApproved.assessment_backlog?.backlog_id)}
              handleViewReport={() => viewReport(item?.assessment_backlog?.backlog_id)}
              handleViewRecommendation={() => handleViewRecommendation(item?.assessment_backlog?.backlog_id)}
              approvalStatus={item?.assessment_backlog?.approval_status || 'Pending'}
            />
          ))
        ) : (
          <div className="no-reports">
            <img src={Noreports} alt="No Reports" width={400} height={400} />
            <p>No Reports to show..</p>
          </div>
        )}
      </div>
    );
  };

  const renderScheduledAssessments = () => {
    if (isLoading === 'loading') {
      return (
        <div>
          <Skeleton height={30} width={200} style={{ marginBottom: "10px" }} />
          <Skeleton count={1} height={200} style={{ marginBottom: "10px" }} />
        </div>
      );
    }
    return (
      <>
        {latestReport && latestReport.firstApproved ? (
          <div className="assessment-container-dashboard">
            <PastAssessmentCard
              key={latestReport.firstApproved.assessment_id}
              data={latestReport.firstApproved} // Passing the whole item as data prop
              assessmentName={latestReport.firstApproved.assessment_name}
              assessmentSubmittedDate=
              {latestReport.firstApproved.submitted_at ? moment(latestReport.firstApproved.submitted_at).tz("Asia/Kolkata").format(
                "DD-MM-YYYY"
              ) : "-"}
              assessorName={latestReport.firstApproved.assessment_backlog?.users?.assessor_name || 'N/A'} // Default 'N/A' if name is not available
              userName={userName}
              handleViewReport={() => viewReport(latestReport.firstApproved.assessment_backlog?.backlog_id)}
              handleViewRecommendation={() =>
                handleViewRecommendation(latestReport.firstApproved.assessment_backlog?.backlog_id)
              }
              referenceName={latestReport.firstApproved.assessment_backlog?.reference_name}
              handleViewAssessment={() => handleViewAssessment(latestReport.firstApproved.assessment_backlog?.backlog_id)}
              showViewReport={true}
              showViewRecommendations={false}
              approvalStatus={latestReport.firstApproved.assessment_backlog?.approval_status || 'Pending'} // Default status if not available
            />
          </div>
        ) : (
          <div className="no-reports">
            <img src={Noreports} alt="No Reports" width={400} height={400} />
            <p>No Reports to show..</p>
          </div>
        )}
      </>
    );
  }

  // const handleDownloadPDF = async () => {
  //   // dispatch(
  //   //   getReportDetailspdfData({
  //   //     assessmentId: reportId,
  //   //     callBack: (data) => {
  //   //       if (data.data.data) {
  //   //         window.open(data.data.data, "_blank", "noreferrer");
  //   //       } else {
  //   //         notifySuccess(data.data.message)
  //   //       }
  //   //     }
  //   //   })
  //   // )
  //   setIsShowDownload(true)
  //   setTimeout(() => {
  //     const options = {
  //       margin: [20, 20, 20, 20], // top, left, bottom, right in mm (or unit of your choice)
  //       filename: "assessment_report.pdf",
  //       image: { type: "jpeg", quality: 0.98 },
  //       html2canvas: { scale: 2, logging: false },
  //       jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  //       pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
  //     };
  //     const element = downloadRef.current;
  //     element.style.display = "block";
  //     if (!element) {
  //       console.error("Element to convert to PDF is not available.");
  //       return;
  //     }
  //     insertManualPageBreaks(element, 2);
  //     // insertManualPageBreaks(element);
  //     // Trigger the download as PDF
  //     html2pdf().from(element).set(options).save("assessment_report.pdf").then(() => element.style.display = "none");
  //     setIsShowDownload(false);
  //   }, 100);
  // }


  // const handleDownloadPDF = async () => {
  //   setIsShowDownload(true);
  //   setisLoader(true)

  //   setTimeout(async () => {
  //     try {
  //       if (downloadRef.current) {
  //         await downloadRef.current.download();
  //       } else {
  //         console.error("Download ref not ready");
  //       }
  //     } catch (err) {
  //       console.error("Download failed", err);
  //     } finally {
  //       setIsShowDownload(false);
  //       setisLoader(false)
  //     }
  //   }, 100);
  // }

  const handleDownloadPDF = async () => {
    if (!reportId) return;

    setIsShowDownload(true);

    try {
      await dispatch(
        getReportDetailspdfData({
          assessmentId: reportId,
          callBack: (data) => {
            const existingUrl = data?.data?.data?.url || data?.data?.data;
            if (
              existingUrl &&
              typeof existingUrl === "string" &&
              existingUrl.startsWith("http")
            ) {
              window.open(existingUrl, "_blank", "noreferrer");
              setIsShowDownload(false);
            }

            else {
              dispatch(
                getPdfData({
                  reportId,
                  callBack: (pdfData) => {
                    if (pdfData) {
                      getScores(pdfData);
                      setPdfReport(pdfData);
                    } else {
                      console.error("No PDF data available.");
                      setIsShowDownload(false);
                    }
                  },
                })
              );
            }
          },
        })
      );
    } catch (error) {
      console.error("Error fetching PDF:", error);
      setIsShowDownload(false);
    }
  };

  useEffect(() => {
    if (pdfReport) {
      triggerDownload();
    }
  }, [pdfReport]);

  const triggerDownload = () => {
    setisLoader(true);

    const currentReportId = reportId;

    setTimeout(async () => {
      try {
        if (downloadRef.current) {
          const pdfBlob = await downloadRef.current.download();

          if (pdfBlob) {
            const formData = new FormData();
            const pdfFile = new File(
              [pdfBlob],
              `Report_${currentReportId}.pdf`,
              { type: "application/pdf" }
            );

            formData.append("files", pdfFile);

            await dispatch(
              multiUpload({
                files: formData,
                callBack: async (uploadedFiles) => {
                  const uploadedUrl = uploadedFiles?.[0]?.url;

                  if (uploadedUrl) {
                    await dispatch(
                      updatePdfURL({
                        reportId: currentReportId,
                        url: uploadedUrl,
                      })
                    );
                  }
                },
              })
            );
          }

          setPdfReport(null);
        } else {
          console.error("Download ref not ready");
        }
      } catch (err) {
        console.error("Download failed", err);
      } finally {
        setIsShowDownload(false);
        setisLoader(false);
      }
    }, 100);
  };



  const renderReportDetails = () => {
    if (isLoading === 'loading') {
      return (
        <div className="skeleton-loader">
          <Skeleton height={150} width="100%" style={{ marginBottom: "20px" }} />
          <Skeleton height={120} width="100%" />
        </div>
      ); // Return skeleton loader when loading
    }
    return (
      <>
        {isLoader ? (
          <div className="loader-wrapper" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh', flexDirection: "column" }}>
            <Loader />
            <div style={{ marginTop: "10px" }}>
              Do not go back or refresh the page while the report is downloading. Please wait.
            </div>
          </div>
        ) : (
          <>
            <div style={{ pointerEvents: "none", marginTop: "-65px", display: "flex", justifyContent: "flex-end", paddingBottom: "20px" }}>
              <Button
                title={showall ? "Preparing Data..." : "Download as PDF"}
                buttonStyle={{
                  width: "auto", height: "48px",
                  backgroundColor: "#1F2155",
                  border: "1.5px solid #1F2155",
                  textAlign: "center",
                  pointerEvents: "auto",
                }}
                titleStyle={{ fontSize: "20px" }}
                onClick={handleDownloadPDF}
              />
            </div>
            <div className="report-group">
              <CardHero
                headingName={
                  reportData?.data?.assessment_details?.assessment_name || "N/A"
                }
                assessorName={
                  reportData?.data?.assessment_details?.assessor_name || "N/A"
                }
                approverName={
                  reportData?.data?.assessment_details?.approver_name || "N/A"
                }
                approvedOn={
                  reportData?.data?.assessment_details?.approved_on
                    ? moment(reportData?.data?.assessment_details?.approved_on).format(
                      "DD-MM-YYYY"
                    )
                    : "-"
                }
                // details="Lorem ipsum dolor sit, amet consectetur adipisicing elit."
                overallRating={reportData?.data?.overall_average_score || "N/A"}
              />

              <div className="view-feedback">
                <h3>Your Feedback</h3>
                <div className="d-flex align-items-center gap-1 fw-bold fs-5">
                  Rating:&nbsp;
                  {[...Array(5)].map((_, idx) =>
                    idx < (feedbackData?.user_rating || 0) ? (
                      <AiFillStar key={idx} className="text-warning" />
                    ) : (
                      <AiOutlineStar key={idx} className="text-secondary" />
                    )
                  )}
                </div>

                <div>{feedbackData?.user_feedback}</div>
              </div>
              {reportData?.data?.performance_results.map((performance) => (
                <DropdownDetails
                  openAll={showall}
                  key={performance.category_id}
                  headingName={performance?.category_name || "Unknown Category"}
                  details={`Click "View Details" to access a comprehensive module-wise breakdown of your scores.`}
                  perfomanceRating={performance?.average_score || "N/A"}
                  // performanceScore="65"
                  scoresData={performance?.sub_categories.map((subCategory) => ({
                    heading: subCategory?.subCategory_name,
                    score: subCategory?.average_score,
                  }))}
                  assessmentId={reportId}
                  score="100%"
                  handleViewDetails={() =>
                    navigate(`/dashboard/${reportId}/${performance.category_id}`,
                      { state: { activetabState: activeTab } }
                    )
                  }
                />
              ))}
            </div>
          </>
        )}
      </>
    )
  };

  const renderContent = () => {
    // Show loading state while initial data is being fetched
    if (isLoading === 'loading') {
      return (
        <div>
          <Skeleton height={30} width={200} style={{ marginBottom: "10px" }} />
          <Skeleton count={4} height={100} style={{ marginBottom: "15px" }} />
        </div>
      );
    }

    // If we're viewing a specific report
    if (reportId) {
      return renderReportDetails();
    }

    // Show appropriate tab content
    switch (activeTab) {
      case "latest":
        return renderScheduledAssessments();
      case "past":
        return renderPastAssessments();
      default:
        return null;
    }
  };

  return (
    <div className="report-container-dashboard">
      {/* Tabs */}
      <div className="d-flex align-items-center"
        onClick={() => {
          setActiveComponent("home"); //
        }}
        style={{ cursor: "pointer" }}>
        <img
          src={BackArrow}
          alt="backarrow"
          width="18px"
          height="18px"

          style={{
            marginLeft: "-5px",
            marginBottom: "-10px",
            cursor: "pointer",
          }}
        />
        <h1 className="report-container-breadcrumb">Back to Dashboard</h1>
      </div>

      <div className="report-slide-button">
        <div
          className={activeTab === "latest" ? "active-tab" : "not-active"}
          onClick={switchToLatest}
          style={{ cursor: "pointer" }}
        >
          Latest Report
        </div>
        <div
          className={activeTab === "past" ? "active-tab" : "not-active"}
          onClick={switchToPast}
          style={{ cursor: "pointer" }}
        >
          Previous Reports
        </div>
      </div>

      {/* Content based on Active Tab */}
      <div>{renderContent()}</div>
      {
        isShowDownload &&
        <ReportDownload ref={downloadRef} resultData={pdfReport} scores={scores} />
      }
    </div>
  );
}
